export const FETCH_ASSET_META_FIELD_URL = `${process.env.REACT_APP_API_URL}/assets_meta_fields`;
export const QUERY_ASSET_META_FIELD_URL = `${process.env.REACT_APP_API_URL}/assets_meta_fields/query`;
export const CREATE_ASSET_META_FIELD_URL = `${process.env.REACT_APP_API_URL}/assets_meta_fields/create`;
export const UPDATE_ASSET_META_FIELD_URL = `${process.env.REACT_APP_API_URL}/assets_meta_fields`;
export const DELETE_ASSET_META_FIELD_URL = `${process.env.REACT_APP_API_URL}/assets_meta_fields`;
export const UPDATE_ASSET_META_FIELD_BY_ASSET_CUSTOM_URL = `${process.env.REACT_APP_API_URL}/assets_meta_fields`;
